var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAudienceSnapshot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.21796 5.62821C10.6341 5.62821 11.7821 4.48022 11.7821 3.0641C11.7821 1.64799 10.6341 0.5 9.21796 0.5M11.782 12.8078H13.8333V12.2517C13.8251 11.47 13.619 10.703 13.234 10.0226C12.8491 9.34206 12.298 8.77029 11.6322 8.36055C11.2018 8.09568 10.7325 7.90413 10.2436 7.7918M5.11538 5.62821C6.53149 5.62821 7.67948 4.48022 7.67948 3.0641C7.67948 1.64799 6.53149 0.5 5.11538 0.5C3.69926 0.5 2.55127 1.64799 2.55127 3.0641C2.55127 4.48022 3.69926 5.62821 5.11538 5.62821ZM0.5 12.8077H9.73077V12.2517C9.72261 11.47 9.51643 10.703 9.13152 10.0226C8.7466 9.34206 8.19549 8.77026 7.52967 8.36053C6.86385 7.95079 6.10504 7.7165 5.32412 7.67953C5.2545 7.67623 5.1849 7.67451 5.11538 7.67437C5.04587 7.67451 4.97627 7.67623 4.90665 7.67953C4.12573 7.7165 3.36692 7.95079 2.7011 8.36053C2.03528 8.77026 1.48417 9.34206 1.09925 10.0226C0.714335 10.703 0.508165 11.47 0.5 12.2517V12.8077Z",
    stroke: "#252938",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudienceSnapshot);
export default __webpack_public_path__ + "static/media/audience-snapshot.6af4c388.svg";
export { ForwardRef as ReactComponent };